import { DATE_MODES } from "@kiwicom/frontend-common/consts/date"
import SearchDate from "@kiwicom/frontend-common/records/SearchDate"
import SearchPlace from "@kiwicom/frontend-common/records/SearchPlace"

import Booking from "../../../../../../../records/Booking"
import type {
  ItineraryChangeSearchForm,
  ItineraryChangeSearchFormFilters,
} from "./AlternativeFlightsDuck.types"
import { MAX_TRAVEL_DURATION_DEFAULT } from "../components/ChangeAlternatives/Filters/consts"

const getCabinType = (cabinType: string) => {
  switch (cabinType) {
    case "economy":
      return "M"
    case "premiumEconomy":
      return "W"
    case "business":
      return "C"
    case "firstClass":
      return "F"
    default:
      return undefined
  }
}

/**
 * If mixed is allowed, should return all lower cabin types
 * If mixed is not allowed, should return undefined
 *
 * @param cabinTypeMixedAllowed
 * @param cabinType - current cabin type
 * @returns {string[]|undefined}
 */
const getMixedCabinTypes = (
  cabinTypeMixedAllowed: boolean,
  cabinType: string,
): string[] | null | undefined => {
  if (!cabinTypeMixedAllowed) return undefined
  switch (cabinType) {
    case "premiumEconomy":
      return ["M"]
    case "business":
      return ["M", "W"]
    case "firstClass":
      return ["M", "W", "C"]
    default:
      return undefined
  }
}

const getOptionalReturnParams = (inboundDate?: SearchDate | null) =>
  // @ts-expect-error: Flow to TS migration.
  inboundDate && inboundDate.mode !== DATE_MODES.NO_RETURN
    ? {
        // @ts-expect-error: Flow to TS migration.
        returnFrom: inboundDate.from,
        // @ts-expect-error: Flow to TS migration.
        returnTo: inboundDate.to,
      }
    : {}

const getMaxTravelDuration = (maxTravelDuration: number) =>
  maxTravelDuration === MAX_TRAVEL_DURATION_DEFAULT ? undefined : maxTravelDuration

const getLocation = (formField: string | SearchPlace) =>
  typeof formField === "string" ? formField : formField.getSearchId()

const createAlternativePayload = (
  booking: Booking,
  { origin, destination, outboundDate, inboundDate }: ItineraryChangeSearchForm,
  sector: number | null | undefined,
  {
    sort,
    cabinType,
    cabinTypeMixedAllowed,
    transportTypes,
    maxTravelDuration,
  }: ItineraryChangeSearchFormFilters,
  partner?: string,
) => {
  return {
    limit: 25,
    sector,
    // @ts-expect-error: Flow to TS migration.
    travelFrom: getLocation(origin),
    // @ts-expect-error: Flow to TS migration.
    travelTo: getLocation(destination),
    // @ts-expect-error: Flow to TS migration.
    dateFrom: outboundDate.from,
    // @ts-expect-error: Flow to TS migration.
    dateTo: outboundDate.to,
    ...getOptionalReturnParams(inboundDate),
    sortField: sort,
    cabinType: getCabinType(cabinType),
    mixedClasses: getMixedCabinTypes(cabinTypeMixedAllowed, cabinType),
    carrierType: transportTypes,
    maxTravelDuration: getMaxTravelDuration(maxTravelDuration),
    partner,
  }
}

export default createAlternativePayload
